import React from 'react';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';

import PageHeader from 'components/ui/page_header';

import SvnHowToLink from '../svn_how_to_link';
import MergeButton from './merge_button';

export default class DuplicatesPageHeader extends React.Component {
  render() {
    return (
      <PageHeader>
        <PageHeader.Heading
          description="Manage your contact database"
          icon={faUsers}
          title="Contacts"
        />
        <PageHeader.Actions>
          <div className="d-none d-md-flex gap-3">
            <SvnHowToLink />
            <MergeButton />
          </div>
        </PageHeader.Actions>
      </PageHeader>
    );
  }
}
